import axios from "axios";
import Api from "../../config/api/axios.urlcontext.js"

export default class CuentasPublicas{
    async getPrincipalCuentasPublicas(url) {
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res;
        } catch (error) {
            console.error(error.message);
        }
    }
    async getAllInfoAnioCuentaPub(url) {
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res;
        } catch (error) {
            console.error(error.message);
        }
    }
    async getInfoCOP(url) {
      try {
          const res = await axios.get(Api.APP_URL_API+url);
          let esArray = Array.isArray(res.data)
          if(esArray){
            return res;
          }
      } catch (error) {
          console.error(error.message);
      }
    }
    async getRelBienes(url) {
        try {
            const res = await axios.get(Api.APP_URL_API+url); ///Api.APP_URL_API+url
            return res;
        } catch (error) {
            console.error(error.message);
        }
    }
    async getEPyPOP(url) {
        try {
            const res = await axios.get(Api.APP_URL_API+url); ///Api.APP_URL_API+url
            return res;
        } catch (error) {
            console.error(error.message);
        }
    }
}